import API from "../../api/apiAdmin";

export const PressService = {
    // --- Press Coverage ---
    getAllPress: async () => {
        const response = await API.get("/admin/press/");
        return response.data;
    },

    getPressById: async (id) => {
        const response = await API.get(`/admin/press/${id}`);
        return response.data;
    },

    createPress: async (data) => {
        const response = await API.post("/admin/press/", data);
        return response.data;
    },

    updatePress: async (id, data) => {
        const response = await API.put(`/admin/press/${id}`, data);
        return response.data;
    },

    deletePress: async (id) => {
        const response = await API.delete(`/admin/press/${id}`);
        return response.data;
    },

    // --- Quotes ---
    getAllQuotes: async () => {
        const response = await API.get("/admin/press/quotes/");
        return response.data;
    },

    getQuoteById: async (id) => {
        const response = await API.get(`/admin/press/quotes/${id}`);
        return response.data;
    },

    createQuote: async (data) => {
        const response = await API.post("/admin/press/quotes/", data);
        return response.data;
    },

    updateQuote: async (id, data) => {
        const response = await API.put(`/admin/press/quotes/${id}`, data);
        return response.data;
    },

    deleteQuote: async (id) => {
        const response = await API.delete(`/admin/press/quotes/${id}`);
        return response.data;
    }
};
